<template>
	<div class="investments-update-box">
		<div class="progress-bar">
			<div class="inner" :style="`width: ${percentage}%`"></div>
		</div>
		{{ $t('home.investments_update') }} ({{ percentage }}%)
	</div>
</template>

<script>
export default {
	name: "InvestmentsUpdateBox",
	data() {
		return {
			interval: null,
			threshold: 0,
			thresholdInterval: null,
			total: 0,
			percentage: 0,
			loading: false,
		}
	},
	methods: {
		updateInvestments() {
			this.axios.get('/api/investments/update-investments').then(response => {
				this.$store.dispatch('replaceProperties', response.data.properties);
				clearInterval(this.interval);
				clearInterval(this.thresholdInterval);
				this.percentage = 100;

				setTimeout(() => {
					this.$store.dispatch('updateMeta', {
						meta: response.data.meta.investments,
						metaKey: 'investments'
					});
				}, 1500);
			});
		},
		checkStatus(){
			if (this.loading){
				return;
			}

			this.loading = true;
			this.axios.get('/api/investments/update-status').then(response => {
				let meta = response.data.meta;
				this.$store.dispatch('updateMeta', {
					metaKey: 'investments',
					meta: meta.investments
				});

				if(meta.total <= meta.updated){
					clearInterval(this.interval);
				} else {
					this.calculateThreshold();
					clearInterval(this.thresholdInterval);
					this.thresholdInterval = setInterval(this.addPercentage, 1500);

					if (meta.investments.progress > this.percentage){
						this.percentage = meta.investments.progress;
					}
				}
			}).finally(() => {
				this.loading =false;
			});
		},
		addPercentage(){
			if(this.percentage >= this.threshold || this.percentage >= 100){
				clearInterval(this.thresholdInterval);
				return;
			}

			this.percentage++;
		},
		calculateThreshold(){
			let meta = this.$store.state.views.meta.investments;
			this.threshold = ((meta.updated + 1) / meta.total * 100) - 5;
		}
	},
	mounted() {
		this.updateInvestments();
		this.calculateThreshold();
		this.interval = setInterval(this.checkStatus, 5000);
		this.thresholdInterval = setInterval(this.addPercentage, 1500);
	}
}
</script>

<style scoped lang="scss">
.investments-update-box {
	text-align: center;
	font-size: 14px;
}
.progress-bar {
	height: 15px;
	position: relative;
	width: 100%;
	margin-bottom: 10px;
	border: 2px solid var(--primary-color, $whiteColor);
	border-radius: 3px;
	overflow: hidden;
}
.inner {
	position: absolute;
	left: 0;
	top: 0;
	bottom: 0;
	background: var(--primary-color, $primaryColor);
	transition: var(--animation-default-duration, $animationDefaultDuration);
	opacity: .6;
}
</style>